export default "data:image/svg+xml,{'error':true,'status':404,'message':'Not%20found','i18n':'error.not_found'}"